import { render } from "./UppercaseConverter.vue?vue&type=template&id=46e149c7"
import script from "./UppercaseConverter.vue?vue&type=script&lang=js"
export * from "./UppercaseConverter.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__